import { Component } from '@angular/core'

import { JointObligorFlows, liquidityAverageOf } from '../../data/utils/joint-obligors.util'
import { LeaseDetailService } from '../../data/services/view/lease-detail.service'

/**
 * ADR-0021 — Render read-only de los flujos bancarios de los OBLIGADOS SOLIDARIOS.
 * Los datos vienen del Excel via `risk-excel-upload`. Sin formularios de captura.
 * F-026 · Una sección por obligado, en el orden de sus hojas («Flujo - OS», «Flujo - OS2»…).
 */
@Component({
	selector: 'app-joint-holder-flows',
	templateUrl: './joint-holder-flows.component.html',
	styleUrls: ['./joint-holder-flows.component.scss'],
})
export class JointHolderFlowsComponent {
	readonly liquidityAverageOf = liquidityAverageOf

	constructor(public leaseDetailService: LeaseDetailService) {}

	get obligors(): JointObligorFlows[] {
		return this.leaseDetailService.jointObligorsBankFlows ?? []
	}

	get hasData(): boolean {
		return this.obligors.length > 0
	}
}
